import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { VerificationStatus } from "../auth-transaction.model";

import { DGA_AUTH_TRANSACTION_ACTION_TYPE } from "./dga-auth-transaction.action";
import { DGA_REGISTRATION_PARTIAL_FLOW_CODES } from "./dga-auth-transaction.const";
import { DgaAuthTransactionState } from "./dga-auth-transaction.model";

const INITIAL_STATE: DgaAuthTransactionState = {};

export function dgaAuthTransactionReducer(state = INITIAL_STATE, action: ActionWithPayload): DgaAuthTransactionState {
	switch (action.type) {
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.setOpenIdConnectUrlSuccess: {
			return updateState(state, {
				openIdConnectUrl: action.payload,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.setCpr: {
			return updateState(state, {
				cpr: action.payload,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.initializeAuthTransaction: {
			return updateState(state, {
				verificationStatus: undefined,
				authenticationToken: undefined,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.reset: {
			return INITIAL_STATE;
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.resetXmlDSig: {
			return updateState(state, {
				xmlDSig: undefined,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatus: {
			return updateState(state, {
				verificationStatus: VerificationStatus.Pending,
				authenticationToken: undefined,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatusFail: {
			return updateState(state, {
				verificationStatus: VerificationStatus.Failed,
				authenticationToken: undefined,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.resetVerificationStatus: {
			return updateState(state, {
				verificationStatus: undefined,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.getExperianData: {
			return updateState(state, {
				experianData: undefined,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.getExperianDataSuccess: {
			return updateState(state, {
				experianData: action.payload,
				experianDataSubmitted: false,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.getExperianDataFail: {
			return updateState(state, {
				experianDataSubmitted: DGA_REGISTRATION_PARTIAL_FLOW_CODES.includes(
					action.payload && action.payload.code
				)
					? false
					: undefined,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.setExperianData: {
			return updateState(state, {
				experianData: action.payload,
				experianDataSubmitted: true,
			});
		}
		case DGA_AUTH_TRANSACTION_ACTION_TYPE.setLoginToRegistrationFlow: {
			return updateState(state, {
				loginToRegistrationFlow: true,
			});
		}
		default:
			return state;
	}
}
